import {
    familyFeatureDropdownButtons,
    familyFeatureDropdownPreviewFree,
    familyFeatureDropdownPreviewPaid,
} from 'reactApp/appHelpers/featuresHelpers/features/familyFunctions';
import { getFamilyAlbumsFeature, getFamilyFoldersFeature } from 'reactApp/modules/family/family.selectors';
import { handleMakeFamilyFolder } from 'reactApp/modules/modifying/sagas/createFolder.saga';
import { historyPush } from 'reactApp/modules/router/router.module';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { store as reduxStore } from 'reactApp/store';
import { sendDwh } from 'reactApp/utils/ga';

import { getCurrentFolder } from './helpers/getCurrentFolder';
import { getSelectedItems } from './helpers/getSelectedItems';

export const makeFamilyFolder = () => {
    const state = reduxStore.getState();
    const selectedItems = getSelectedItems(state);
    const currentFolder = getCurrentFolder(state);

    const hasFamilyFoldersFeature = getFamilyFoldersFeature(state);
    const hasFamilyAlbumsFeature = getFamilyAlbumsFeature(state);
    const isFamilyTariff = hasFamilyFoldersFeature && hasFamilyAlbumsFeature;
    const isPaid = UserSelectors.isPaidUser(state);

    const showToFreeUser = familyFeatureDropdownPreviewFree && !isPaid;
    const showToPaidUser = familyFeatureDropdownPreviewPaid && isPaid;

    sendDwh({
        eventCategory: 'dropdown-make-family-folder-click',
        dwhData: {
            is_family_member: isFamilyTariff ? 1 : 0,
        },
    });

    if (!hasFamilyFoldersFeature && !hasFamilyAlbumsFeature && (showToFreeUser || showToPaidUser)) {
        sendDwh({
            eventCategory: 'dropdown-make-family-folder-redirect',
            dwhData: {
                is_family_member: isFamilyTariff ? 1 : 0,
            },
        });
        reduxStore.dispatch(historyPush({ id: `/family/folders/` }));
    }

    if (hasFamilyFoldersFeature && hasFamilyAlbumsFeature && familyFeatureDropdownButtons) {
        handleMakeFamilyFolder(selectedItems[0] || currentFolder, !selectedItems[0]);
    }
};
